/**
 * Initialize Iubenda Cookie Solution with the customer's configuration
 * @param {Object} config - Customer's Iubenda configuration
 */
export const initializeIubenda = (config) => {
  const language = window.navigator.userLanguage || window.navigator.language;
  const isEnglish = language && language.includes('en');
  const policyLang = isEnglish ? 'en-GB' : 'it';
  const cookiePolicyId = isEnglish ? config.cookiePolicyId.en : config.cookiePolicyId.it;

  if (!cookiePolicyId || !config.siteId) {
    console.warn('Iubenda not initialized: missing siteId or cookiePolicyId');
    return;
  }

  window._iub = window._iub || [];
  window._iub.csConfiguration = {
    lang: policyLang,
    siteId: config.siteId,
    cookiePolicyId: cookiePolicyId,
    invalidateConsentWithoutLog: true,
    consentOnContinuedBrowsing: false,
    perPurposeConsent: true,
    whitelabel: false,
    floatingPreferencesButtonDisplay: 'bottom-left',
    footer: {},
    banner: {
      closeButtonRejects: true,
      acceptButtonDisplay: true,
      customizeButtonDisplay: true,
      rejectButtonDisplay: true,
      explicitWithdrawal: true,
      position: 'bottom'
    },
    callback: {
      onPreferenceExpressedOrNotNeeded: function(preference) {
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            iubenda_ccpa_opted_out: window._iub.cs.api.isCcpaOptedOut()
          });
          if (!preference) {
            window.dataLayer.push({
              event: 'iubenda_preference_not_needed'
            });
          } else {
            if (preference.consent === true) {
              window.dataLayer.push({
                event: 'iubenda_consent_given'
              });
            } else if (preference.consent === false) {
              window.dataLayer.push({
                event: 'iubenda_consent_rejected'
              });
            } else if (preference.purposes) {
              for (var purposeId in preference.purposes) {
                if (preference.purposes[purposeId]) {
                  window.dataLayer.push({
                    event: 'iubenda_consent_given_purpose_' + purposeId
                  });
                }
              }
            }
          }
        }
      }
    }
  };

  // Load Iubenda script if not already present
  if (!document.querySelector('script[src*="iubenda_cs.js"]')) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//cdn.iubenda.com/cs/iubenda_cs.js';
    script.charset = 'UTF-8';
    script.async = true;
    document.head.appendChild(script);
    console.log('Iubenda initialized with siteId:', config.siteId);
  }
};
